export default "__VITE_ASSET__BYDFT$G___"